import { HTTP_INTERCEPTORS, HttpEvent, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpClient } from '@angular/common/http';
import { TokenStorageService } from './token-storage.service';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { ToastrService, Toast } from 'ngx-toastr';
import { AuthService } from './auth.service';
import {Router} from "@angular/router";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private token: TokenStorageService,
              private toastr: ToastrService,
              public router: Router,
              private authSvr: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req;
    const token = this.token.getToken();

    if (token) {
      authReq = req.clone({
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          // tslint:disable-next-line: object-literal-key-quotes
          'Authorization': `Bearer ${ token }`
        })
      });
    }
    return next.handle(authReq)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMessage = '';
          if (this.authSvr.isLoggedIn){
            if (error.status === 0){
              errorMessage = 'POPS API en mantenimiento.';
              this.toastr.error(errorMessage);
            }else if (error.status === 401){
              errorMessage = 'Sesión expirada';
              const keys = Object.keys(sessionStorage).filter(x => x.indexOf('authority') > 0)
              keys.forEach(x => sessionStorage.removeItem(x));
              this.authSvr.logout();
            } else if (error.status === 403){
              errorMessage = 'Usuario no tiene permisos para acceder.';
              this.toastr.error(errorMessage);
            }else{
              if (error.error instanceof ErrorEvent) {
                // client-side error
                errorMessage = `Error: ${error.error.message}`;
                this.toastr.warning(errorMessage);
              } else {
                // server-side error
                // The backend returned an unsuccessful response code.
                // The response body may contain clues as to what went wrong,
                if (error.error && error.error.error){
                  errorMessage = error.error.error;
                }else{
                  errorMessage = error.error && error.error.fullMessages ?
                                error.error.fullMessages.toString() :
                                `Error Code: ${error.status}\nMessage: ${error.message}`;
                }
                this.toastr.error(errorMessage);
                }
            }
          }else{
            this.authSvr.login();
          }
          return throwError(errorMessage);
        })
      );
  }
}

export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];
